import { AlertCircle, AlertTriangle, Info, RefreshCw } from 'lucide-react';
import type { ReactNode } from 'react';
import { tx } from '../i18n';

interface NoticeProps {
  tone?: 'info' | 'warning' | 'error';
  title?: string;
  children: ReactNode;
  onRetry?: () => void;
}

const ICONS = {
  info: Info,
  warning: AlertTriangle,
  error: AlertCircle,
} as const;

/** Inline, non-blocking message with an optional retry. */
export default function Notice({ tone = 'info', title, children, onRetry }: NoticeProps) {
  const Icon = ICONS[tone];
  const className = tone === 'info' ? 'notice' : `notice notice--${tone}`;

  return (
    <div className={className} role={tone === 'error' ? 'alert' : 'status'}>
      <Icon size={18} aria-hidden="true" />
      <div style={{ flex: 1 }}>
        {title ? <p className="notice__title">{title}</p> : null}
        <div>{children}</div>
      </div>
      {onRetry ? (
        <button type="button" className="button button--secondary button--small" onClick={onRetry}>
          <RefreshCw size={14} aria-hidden="true" />
          {tx('Try again', 'Tekrar dene',
    'Spróbuj ponownie',
    'Tentar novamente',
    'Reintentar')}
        </button>
      ) : null}
    </div>
  );
}
